import React, { Component } from "react";
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Row,
    Col,
    Label
} from "reactstrap";
import { Button, TableRow } from "@material-ui/core";
import ReactToPrint from "react-to-print";

class ViewQRModal extends Component {
    render() {
        const { isOpen } = this.props;
        const { qr } = this.props;
        const { close } = this.props;

        return (
            <Modal isOpen={isOpen}>
                <ModalHeader>View Equipment</ModalHeader>
                <ModalBody>
                    <Row>
                        <Col>
                            <Label>QR Code</Label>
                            <p>
                                <TableRow ref={el => (this.componentRef = el)}>
                                    {qr.qr_code_url ? (
                                        <img
                                            alt="profile avatar"
                                            src={qr.qr_code_url}
                                            style={{
                                                height: 220,
                                                width: 200
                                            }}
                                        />
                                    ) : (
                                        "No QR Code Available"
                                    )}
                                </TableRow>
                            </p>
                        </Col>
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <ReactToPrint
                        trigger={() => (
                            <Button variant="contained" color="primary">
                                Print
                            </Button>
                        )}
                        content={() => this.componentRef}
                    />
                    <Button variant="contained" onClick={() => close()}>
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>
        );
    }
}
export default ViewQRModal;
